import { RootState } from '@reducers';

export const selectOtpCode = (state: RootState) => state.userRegistrationReducer.otpCode;
